import React from "react";
import i18n from "../../../../i18n/i18n";
import ModifyItem from "../../dictionary/modifyItem/modifyItem";
import {withRouter} from "react-router";
import {DictionariesOwnedVehiclesModel} from "../../../models/dictionariesOwnedVehicles";
import {DictionariesOwnedVehiclesService} from "../../../services/dictionariesOwnedVehiclesService";
import OwnedVehicleForm from "../ownedVehicleForm/ownedVehicleForm";

class ModifyOwnedVehicle extends ModifyItem<DictionariesOwnedVehiclesModel> {
    constructor(props: any) {
        super(props);
    }

    async componentDidMount() {
        this.getItem(await DictionariesOwnedVehiclesService.getOwnedVehicle(this.props.match.params?.id));
    }

    render() {
        return (
            <div className="modify-owned-vehicle modify-record">
                <div className="content">
                    {this.renderHeader(i18n.t("dictionaries.ownedVehicles.actions.modifyOwnedVehicle.header"))}
                    {this.renderContent(<OwnedVehicleForm isUpdate={true} ownedVehicleData={this.state.item}/>)}
                </div>
            </div>
        );
    }
}
export default withRouter(ModifyOwnedVehicle);
